import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { depositToClientAccount } from '@app/dev/actions/terminal';
import { useTranslation } from '@common/hooks/translation';
import { PopupContext } from '@app/dev/contexts/popup';

import './style.scss';

const MatchedClientIdPopup = ({ client }) => {
  const t = useTranslation();
  const dispatch = useDispatch();
  const [{ closePopup }] = useContext(PopupContext);

  return (
    <div className="popup-content popup-small">
      <h3 className="popup-title">{t('Found one match')}</h3>
      <div className="popup-main-content">
        <i className="global-icon icon-success-empty client-success-icon" />
      </div>
      <div className="popup-actions">
        <div className="matched-client-inp-wrapper">
          <p>{t('Client id')}</p>
          <input value={client.Id} readOnly className="matched-client-inp" />
          <div className="matched-btn-wrapper">
            <button
              type="button"
              className="popup-cancel-button"
              onClick={closePopup}
            >
              {t('cancel')}
            </button>
            <button
              type="button"
              className="popup-confirm-button"
              onClick={() => dispatch(depositToClientAccount(JSON.stringify(client.Id)))}
            >
              {t('confirm')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatchedClientIdPopup;

MatchedClientIdPopup.propTypes = {
  client: PropTypes.object,
};
